import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large CompaniesActions",
    title: "Почта клиентов",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSet
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        placeholder: "Согласовант (email)",
        value: _ctx.state.approvingEmail,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.approvingEmail) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Подписант (email)",
        "is-invalid": _ctx.state_form$.signerEmail.$error,
        "validation-errors": _ctx.state_form$.signerEmail.$errors,
        value: _ctx.state.signerEmail,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.signerEmail) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}